/* eslint-disable jsx-a11y/click-events-have-key-events */
import cx from 'classnames';
import Above from 'modules/common/Svg/Above';
import ArrowDown from 'modules/common/Svg/ArrowDown';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {circle, TopTab} from './styles.scss';

class TabClick extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: false,
      codeReviewTab: false,
    };
  }

  toggleTab = () => {
    this.setState((state) => ({
      tab: !state.tab,
      codeReviewTab: !state.codeReviewTab,
    }));
  };

  render() {
    return (
      <div
        className={cx('bg-white', {
          'ba b--light-gray br1': this.props.isCodeReview,
        })}
      >
        <div
          className={cx('ph3 pointer', TopTab, this.props.color, {
            ltr: this.props.isOutput || this.props.isCodeReview,
          })}
          onClick={this.toggleTab}
        >
          <div className="flex justify-between">
            <div className="flex overflow-x-scroll overflow-y-hidden">
              <h4>{this.props.title}</h4>
              {this.props.codeReviewCount && (
                <span className={`${circle} mh4`}>
                  {this.props.codeReviewCount}
                </span>
              )}
            </div>
            <div className="flex items-center rtl">
              {this.props.points}
              {this.state.tab || this.state.codeReviewTab ? (
                <ArrowDown color="black-80" width="13px" height="13px" />
              ) : (
                <Above color="black-80" width="13px" height="13px" />
              )}
            </div>
          </div>
        </div>
        <div
          className={cx('pv2', {
            dn: this.state.tab && !this.props.isCodeReview,
            db: !this.state.tab && !this.props.isCodeReview,
            'db code-review':
              this.state.codeReviewTab && this.props.isCodeReview,
            'dn code-review':
              !this.state.codeReviewTab && this.props.isCodeReview,
            'overflow-x-auto tl ltr bg-black': this.props.isCodeReview,
          })}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

TabClick.propTypes = {
  title: PropTypes.node.isRequired,
  points: PropTypes.node,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  isOutput: PropTypes.bool,
  isCodeReview: PropTypes.bool,
  codeReviewCount: PropTypes.node,
};

export default TabClick;
